

var _cardMetaData = require('../cardMetaData');

require('xo-ui-components/src/tooltip/directive');

require('xo-ui-components/src/directionality/directive');

require('xo-ui-components/src/error-tooltip/directive');

require('../cardExpiry/directive');

require('../cvv/directive');

require('../dob/directive');

define(['squid/index', 'text!./template.html', 'jquery', 'components/xo-models/src/fi/index', 'components/angular-ui-utils/ui-utils.min', 'components/xo-form-components/src/name-input/directive'], function (squid, template, $) {

    squid.module('xo-add-card.creditcard-input.directive', ['squid', 'xomodel.fi', 'xo-tooltip.directive', 'xo-error-tooltip.directive', 'xo-name-input.directive', 'ui.validate']).directive('scrollToTop', function () {
        return {
            link: function link(scope, element, attr) {
                $(element).on('focus', function () {
                    if ($('#mxCardTitle').is(':visible')) {
                        $('#creditCardForm').scrollTop($(element).offset().top);
                    }
                });
            }
        };
    }).directive('xoCreditCard', function ($timeout, $util) {
        return {
            template: template,
            restrict: 'E',

            scope: {
                token: '=',
                card: '=',
                user: '=',
                selectedPromotionCardType: '=',
                promotion: '=',
                cardTypeChanged: '=',
                cardNumberChanged: '=',
                manageCardFlow: '='
            },
            controller: function controller($scope, $populate, $CardTypesModel, $Class, $locale, $CardTypeFromBinModel, $config, $feature, $pxp, $logger, $stateParams, $FlowEligibilityModel, $meta) {
                $populate($scope, {
                    flowEligibility: $FlowEligibilityModel.instance($scope.token).retrieve({
                        params: {
                            geolocation: $meta.geolocation,
                            localeCountry: $locale.country
                        }
                    })
                }).then(function () {
                    $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';

                    $scope.locale = $locale;
                    $scope.country = $scope.locale.country;

                    var cardTypeServiceCall = $feature('cardTypeServiceCallRequired', false, $scope.country) || $scope.debitCardFlow;
                    var isUnsupportedCard;
                    var lastVerifiedBin = '';
                    var lastRequestedBin; // bin requested to service to fetch card type and pending response.

                    $scope.mxDebitCards = ['BANAMEX', 'BANCOARFACA', 'BBVA', 'BANORTE', 'HSBC', 'INBURSA', 'SANTANDER'];

                    $scope.cardLengthValid = function (number) {
                        if ($scope.card && $scope.card.isExisting()) {
                            return true;
                        }

                        number = (number || '').replace(/[^0-9]+/g, '');

                        return number.length >= $scope.flag('length.min') && number.length <= $scope.flag('length.max');
                    };

                    $scope.cardLuhnValid = function (input) {

                        if (!$scope.flag('luhn')) {
                            return true;
                        }

                        if ($scope.card && $scope.card.isExisting()) {
                            return true;
                        }

                        input = (input || '').replace(/[^0-9]+/g, '');

                        var sum = 0;
                        var numdigits = input.length;
                        var parity = numdigits % 2;
                        var i = 0;
                        var digit;

                        for (; i < numdigits; i++) {

                            digit = parseInt(input.charAt(i), 10);

                            if (i % 2 === parity) {
                                digit *= 2;
                            }

                            if (digit > 9) {
                                digit -= 9;
                            }

                            sum += digit;
                        }

                        return sum % 10 === 0;
                    };

                    $scope.isPlcc = $scope.selectedPromotionCardType && $scope.selectedPromotionCardType.type === 'plcc' ? true : false;

                    $scope.flag = function (field) {
                        if ($scope.isPlcc && !$scope.card.type) {
                            $scope.card.type = 'PLCC';
                        }
                        return _cardMetaData.$CardMetaData.getMetaData($scope.card, field);
                    };

                    $scope.maxLength = function () {

                        if ($scope.card && $scope.card.isExisting()) {
                            return 30;
                        }

                        return $scope.flag('length.max') + $scope.flag('spaces.length');
                    };

                    if ($scope.card && $scope.card.number) {
                        $scope.unformattedCardNumber = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());
                    }

                    $scope.showMXCardLogos = function () {
                        return $locale.country === 'MX';
                    };

                    function pxpMXCardLabels() {
                        if ($scope.showMXCardLogos()) {
                            $pxp('xo_hermes_mx_cardlogo', {}, 'xo_hermes_mx_cardlogo_treatment').then(function (result) {
                                $scope.showLabels = result && result.treatment_name === 'xo_hermes_mx_cardlogo_treatment';
                            });
                        } else {
                            $scope.showLabels = false;
                        }
                    }

                    $populate($scope, {
                        cardTypes: $CardTypesModel.instance($scope.token + ':' + $locale.country, {
                            token: $scope.token,
                            country: $locale.country
                        })
                    }).then(function () {
                        var forceDropDown = false;

                        function str(item) {
                            var s = item.toString();
                            return item < 10 ? '0' + s : s;
                        }

                        $scope.supportedCardNamesCommaSeparated = $scope.cardTypes.supportedNames().join(', ');

                        $scope.$on('localeChange', function () {

                            $scope.cardTypes = $CardTypesModel.instance($scope.token + ':' + $locale.country, {
                                token: $scope.token,
                                country: $locale.country
                            });

                            $scope.cardTypes.retrieve().then(function () {
                                if ($scope.card.type && $scope.cardTypes.allowed.indexOf($scope.card.type) === -1) {
                                    delete $scope.card.type;
                                    forceDropDown = false;
                                    $scope.changeCardNumber(true);
                                }
                            });

                            $scope.country = $locale.country;

                            pxpMXCardLabels();
                        });

                        pxpMXCardLabels();

                        $scope.cvvShown = function () {
                            if ($scope.card.type === 'CETELEM' && $scope.locale.country === 'FR') {
                                return false;
                            }

                            if ($scope.card.type === 'CUP' && $scope.card.productType === 'DEBITCARD') {
                                return false;
                            }

                            if ($scope.isPlcc && $scope.card.type) {
                                return true;
                            }

                            return $scope.flag('fields.cvv');
                        };

                        $scope.expiryShown = function () {

                            if ($scope.isPlcc && $scope.card.type) {
                                return true;
                            }
                            if ($scope.card.type === 'CUP' && $scope.card.productType === 'DEBITCARD') {
                                return false;
                            }

                            return $scope.flag('fields.expiry');
                        };

                        $scope.enableDropDown = function () {
                            return Boolean(['ES', 'FR', 'GB', 'IT'].indexOf($scope.locale.country) > -1) || forceDropDown;
                        };

                        $scope.showDropDown = function () {

                            if ($scope.enableDropDown()) {
                                return true;
                            }

                            if (!$scope.card.type && $scope.card.number && $scope.card.number.length >= 4 && !cardTypeServiceCall && !$scope.isPlcc) {
                                return true;
                            }

                            if (!$scope.card.type && $scope.card.number && $scope.card.number.length >= 7 && cardTypeServiceCall && isUnsupportedCard) {
                                return true;
                            }

                            return false;
                        };

                        $scope.showAcceptedCardLogos = function () {
                            return !$scope.showDropDown() && $feature('showAcceptedCardLogos', false, $scope.country);
                        };

                        $scope.getCardTypeByNumber = function (types, number) {
                            if ($scope.isPlcc && number.length > 6 || !$scope.isPlcc) {
                                return _cardMetaData.$CardMetaData.getCardType(types, number);
                            }
                        };

                        function formatCardNumber(number) {
                            var spaces = $scope.flag('spaces');
                            var formatted = [];

                            for (var i = 0; i < number.length; i++) {
                                if (spaces.indexOf(i) > -1) {
                                    formatted.push(' ');
                                }

                                formatted.push(number.charAt(i));
                            }

                            number = formatted.join('');
                            return number;
                        }

                        $scope.$watch('card.type', function () {
                            if ($scope.cardTypeChanged) {
                                $scope.cardTypeChanged();
                            }
                        });

                        /**
                         * Hit Callback(unformatted cc no) when user gets out of the cardNumber field.
                         */
                        $scope.ccOnBlur = function () {
                            if ($scope.cardNumberChanged) {
                                $scope.cardNumberChanged($scope.unformattedCardNumber);
                            }
                        };

                        // e.g for a dual brand = ['CUP' ,'VISA'], select VISA or CUP based
                        // on regex defined for card type. If not regex was defined, pick one
                        // of the allowed card type.
                        function selectCardTypeForDualBrands(result) {
                            var dualCardTypes = $feature('dualCardTypes', {});
                            var match;
                            Object.keys(dualCardTypes).some(function (key) {
                                return result.some(function (cardType) {
                                    if (cardType.type === key) {
                                        match = key;
                                        return true;
                                    }
                                });
                            });

                            if (match) {
                                var regex = new RegExp(dualCardTypes[match]);
                                var selected = $util.find(result, function (cardType) {
                                    if (regex.test(cardType.type)) {
                                        return true;
                                    }
                                });
                                if (selected && selected.type === 'CUP') {
                                    $util.some(result, function (cardType) {
                                        if (/^AMEX$/.test(cardType.type)) {
                                            selected.dualType = cardType.type;
                                            return true;
                                        }
                                    });
                                }

                                return selected;
                            } else {
                                return $util.find(result, function (cardType) {
                                    return $scope.cardTypes.allowed.indexOf(cardType.type) > -1;
                                });
                            }
                        }

                        function selectCardType(result) {
                            if (angular.isArray(result)) {
                                if (result.length >= 2) {
                                    result = selectCardTypeForDualBrands(result);
                                } else {
                                    result = result[0];
                                }
                            }

                            return result || {};
                        }

                        function clearCardType() {
                            $scope.card.type = '';
                            $scope.card.dualType = '';
                            $scope.card.productType = '';
                        }

                        function getCardTypeByNumberServiceCall(number) {
                            if (number.length >= 6) {
                                var bin = number.slice(0, 6);

                                if (lastVerifiedBin && lastVerifiedBin.bin === bin) {
                                    $scope.card.type = lastVerifiedBin.type;
                                    $scope.card.dualType = lastVerifiedBin.dualType;
                                    $scope.card.productType = lastVerifiedBin.productType;
                                    return;
                                }

                                if (isUnsupportedCard === bin || bin === lastRequestedBin) {
                                    return;
                                }

                                lastRequestedBin = bin;

                                var params = {
                                    country: $scope.country,
                                    user_country: $scope.country,
                                    bin: bin
                                };

                                $scope.cardTypeFromBinModel = new $CardTypeFromBinModel(params);

                                $scope.cardTypeFromBinModel.retrieve({
                                    silent: true,
                                    success: function success(result) {
                                        result = selectCardType(result);
                                        var type = result.type;
                                        lastRequestedBin = undefined;

                                        var disallowedCard = false;
                                        if ($scope.cardTypes.allowed.indexOf(type) === -1) {
                                            disallowedCard = true;
                                        } else if ($scope.debitCardFlow) {
                                            if (result.productType !== 'DEBIT') {
                                                disallowedCard = true;
                                            }
                                        }

                                        if (disallowedCard) {
                                            clearCardType();
                                            isUnsupportedCard = bin;
                                            $scope.allowedCardsTooltip = true;
                                            return;
                                        }

                                        isUnsupportedCard = undefined;
                                        forceDropDown = false;
                                        if (!$scope.showDropDown()) {
                                            $scope.card.type = type;
                                            $scope.card.dualType = result.dualType;
                                            $scope.card.productType = result.productType;
                                        }

                                        lastVerifiedBin = {
                                            bin: bin,
                                            type: type,
                                            dualType: result.dualType,
                                            productType: result.productType
                                        };

                                        // This logic is to handle copy paste case when all numbers are entered at once
                                        if ($scope.card.type && number.length >= $scope.flag('length.min')) {
                                            if (/android/i.test(navigator.userAgent)) {
                                                return;
                                            }

                                            var ccNumber = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());

                                            if (ccNumber.indexOf(number) >= 0) {
                                                $scope.card.number = formatCardNumber(ccNumber);
                                            }
                                        }

                                        return;
                                    },
                                    contingencies: {
                                        GET_FI_ISSUER_DETAILS_ERR: function GET_FI_ISSUER_DETAILS_ERR(name, result) {
                                            clearCardType();
                                            isUnsupportedCard = bin;
                                            lastRequestedBin = undefined;
                                        }
                                    },
                                    error: function error() {
                                        clearCardType();
                                        isUnsupportedCard = bin;
                                    }
                                });
                            } else {
                                isUnsupportedCard = undefined;
                                lastRequestedBin = undefined;
                                forceDropDown = false;
                                clearCardType();
                            }
                        }

                        $scope.getAllowedCardTypeByNumber = function (number) {
                            return $scope.getCardTypeByNumber($scope.cardTypes.allowed, number);
                        };

                        $scope.getDisallowedCardTypeByNumber = function (number) {
                            return $scope.getCardTypeByNumber($scope.cardTypes.disallowed, number);
                        };

                        $scope.enableAddMode = function () {

                            if ($scope.card.isExisting()) {
                                $scope.card.number = '';
                            }
                        };

                        $scope.changeType = function () {
                            forceDropDown = true;

                            $scope.changeCardNumber(true);

                            // Blank out unsupported fields

                            if (!$scope.flag('fields.expiry')) {
                                delete $scope.card.expiry_month;
                                delete $scope.card.expiry_year;
                            }

                            if (!$scope.flag('fields.issue')) {
                                delete $scope.card.start_month;
                                delete $scope.card.start_year;
                                delete $scope.card.issue_number;
                            }

                            if (!$scope.flag('fields.dob')) {
                                delete $scope.card.dob_day;
                                delete $scope.card.dob_month;
                                delete $scope.card.dob_year;
                            }

                            if (!$scope.flag('fields.cvv')) {
                                delete $scope.card.security_code;
                            }
                        };

                        $scope.changeCardNumber = function (isCardTypeChanged) {
                            // If buyer tries to modify an update card number. We remove the whole string
                            // so buyer can add a card instead.
                            $scope.enableAddMode();
                            $scope.allowedCardsTooltip = false;

                            var regex = /[０-９]/;
                            if ($feature('disableFullWidthCharacters') && regex.test($scope.card.number)) {
                                $logger.info('checkout_fpti', {
                                    'is_fullwidth_character': true
                                });
                            }

                            var number = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());
                            var formattedNumber;

                            $scope.unformattedCardNumber = number;

                            // Attempt to determine the card type

                            var cardType;

                            if (cardTypeServiceCall) {
                                if (!isCardTypeChanged) {
                                    getCardTypeByNumberServiceCall(number);
                                }

                                if (isUnsupportedCard) {
                                    $scope.allowedCardsTooltip = true;
                                }
                            } else {
                                if (!isCardTypeChanged) {
                                    // Hide dropdown and trigger bin matching when the cc number is < 4 digits
                                    if (number.length < 4) {
                                        forceDropDown = false;
                                    }

                                    if (!$scope.enableDropDown()) {
                                        cardType = $scope.getAllowedCardTypeByNumber(number);
                                        $scope.card.type = cardType.type;
                                        $scope.card.subType = cardType.subType;
                                    }
                                }

                                if ($scope.isPlcc && $scope.card.type) {
                                    $scope.cvvShown();
                                    $scope.expiryShown();
                                }

                                if (!$scope.card.type && !$scope.isPlcc && (number.length >= 4 || $scope.getDisallowedCardTypeByNumber(number).type)) {
                                    $scope.allowedCardsTooltip = true;
                                }
                            }

                            // Format the card number

                            /*
                             * PPPLMER-1563 commented out to fix this bug
                             if (/android/i.test(navigator.userAgent)) {
                             return;
                             }
                             */

                            formattedNumber = formatCardNumber(number);

                            // If the card is already formatted correctly, we can leave the user to continue in peace.
                            if ($scope.card.number === formattedNumber) {
                                return;
                            }

                            // Wait for the user's input to be reflected on the page (necessary for safari 5 otherwise selectionStart is incorrect)
                            $timeout(function () {

                                // re-formatting the number, since the card type may not have resolved before the first call
                                $scope.card.number = formatCardNumber(number);

                                // Save the current cursor positions
                                var ccField = document.getElementById('cc');
                                if (!ccField) {
                                    return;
                                }
                                var inputLength = ccField.value.length;
                                var cursorStart = ccField.selectionStart;

                                // Wait for the formatted card to be reflected on the page
                                $timeout(function () {

                                    // If the cursor was at the end of the input field, keep it at the end
                                    if (cursorStart === inputLength) {
                                        ccField.selectionStart = ccField.selectionEnd = ccField.value.length;
                                        // Otherwise place the cursor to the position it was in before we replaced with the formatted number
                                    } else {
                                        ccField.selectionStart = ccField.selectionEnd = cursorStart;
                                    }
                                });
                            });
                        };

                        var year = new Date().getFullYear();
                        $scope.months = $util.map($util.range(1, 13), str);
                        $scope.startYears = $util.map($util.range(year - 10, year), str);
                    });
                });
            }
        };
    });
});

_cardMetaData.$CardMetaData;


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/add-card/creditcard-input/directive.js
// module id = ./components/xo-wallet-components/src/add-card/creditcard-input/directive.js
// module chunks = 1